import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { drawGraph } from 'modules/Statistics/Pulse/components/ChartPreview/drawGraf'
import styles from 'modules/Statistics/Pulse/components/ChartPreview/ChartPreview.module.scss'

export const ChartPreview = ({ data = [], isActive = false, diff = null }) => {
  const canvasRef = useRef()
  let timeout

  const COLORS =
    (diff && diff.number > 0) || !diff
      ? ['#00B530', '#00B530']
      : ['#F04C41', '#F04C41']

  useEffect(() => {
    initGraph()
  }, [isActive, data])

  const initGraph = () => {
    drawGraph({
      canvas: canvasRef.current,
      dataArr: data.map((n) => n || 0),
      color: isActive ? COLORS[1] : COLORS[0],
    })
  }

  const handleResize = () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      initGraph()
    }, 300)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className={styles['chart-preview-container']}>
      <div className={styles['chart-preview']}>
        <canvas ref={canvasRef} />
      </div>
    </div>
  )
}

ChartPreview.defaultProps = {
  data: [],
  isActive: false,
  diff: null,
}

ChartPreview.propTypes = {
  data: PropTypes.array,
  isActive: PropTypes.bool,
  diff: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
}
